<template>
  <section id="login">
    <div style="margin-top:100px; margin-bottom:150px">
      <!-- Login Form -->

      <div style="margin:auto; padding:0px" class="container h-100 d-flex justify-content-center">
        <div class="login my-auto">
          <button type="button" aria-label="Close" class="close" @click="volver()">×</button>
          <transition name="slideAnim" type="animation" appear mode="out-in">
            <div class="modal-arkidia" style="text-align:left; ">
              <div v-if="successMessage" class="alert alert-success" role="success">
                <h5 style="text-align:center">{{successMessage}}!</h5>
              </div>

              <div
                v-if="arkidians.length>0 && !ingresaOtraCuenta && !loginNuevoUsuario"
                style="padding-top:20px; border-radius:15px"
              >
                <h4 style="text-align:center; padding-bottom:15px">Elegí una cuenta</h4>

                <div>
                  <b-card
                    no-body
                    class="overflow-hidden"
                    style="cursor:pointer; background-color: #ffffff00; border:0px"
                    v-for="(ark,index) in arkidians"
                    v-bind:key="index"
                    @click="elegirArkidian(ark,index)"
                  >
                    <b-row no-gutters>
                      <b-col md="12" style="padding-bottom:15px">
                        <b-row>
                          <b-col cols="2">
                            <arkidian
                              style="margin:auto; border-radius:50%; width:50px; "
                              :preferencias="ark.preferencias"
                            ></arkidian>
                          </b-col>
                          <b-col cols="10">
                            <h6>{{ark.nombre}}</h6>
                            <p style="color:grey; font-size: 15px">{{ark.usuario}}</p>
                            <b-img
                              v-if="eliminaArkidian"
                              src="./public/images/site/deleteUser.svg"
                              style="width:20px; float:right; margin-top:-40px"
                            ></b-img>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-card>

                  <hr style="margin-top:0px" />

                  <b-card
                    no-body
                    class="overflow-hidden"
                    style="cursor:pointer; background-color: #ffffff00; border:0px"
                    v-if="!eliminaArkidian"
                    @click="usarOtraCuenta()"
                  >
                    <b-row no-gutters>
                      <b-col md="12" style="padding-bottom:15px">
                        <b-row>
                          <b-col cols="2">
                            <b-img
                              src="./public/images/site/newUser.svg"
                              style="margin:auto; border-radius:50%; width:50px"
                            ></b-img>
                          </b-col>
                          <b-col cols="10">
                            <h6 style="padding-top:10px">Usá otra cuenta</h6>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-card>

                  <b-card
                    no-body
                    class="overflow-hidden"
                    style="cursor:pointer; background-color: #ffffff00; border:0px"
                    v-if="!eliminaArkidian"
                    @click="eliminaArkidian=true"
                  >
                    <b-row no-gutters>
                      <b-col md="12" style="padding-bottom:15px">
                        <b-row>
                          <b-col cols="2">
                            <b-img
                              src="./public/images/site/removeUser.svg"
                              style="margin:auto; border-radius:50%; width:50px"
                            ></b-img>
                          </b-col>
                          <b-col cols="10">
                            <h6 style="padding-top:10px">Eliminá una cuenta</h6>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </b-card>
                </div>
                <button
                  type="button"
                  class="btn boton-primario"
                  v-if="eliminaArkidian"
                  @click="eliminaArkidian=false"
                >Listo</button>
              </div>

              <div
                v-if="ingresaOtraCuenta&&arkidianSeleccionado"
                style="padding:20px; border-radius:15px"
              >
                <h4
                  style="text-align:center; margin-botto:-10px"
                >Hola {{arkidianSeleccionado.nombre}}</h4>
                <h6 style="text-align:center; padding:0px ">({{arkidianSeleccionado.usuario}})</h6>

                <arkidian
                  style="margin:auto; border-radius:50%; width:200px; cursor:pointer"
                  :preferencias="arkidianSeleccionado.preferencias"
                ></arkidian>

                <div class="form-group">
                  <label>Contraseña</label>
                  <input
                    type="password"
                    class="form-control"
                    v-on:keyup.enter="hacerLogin(login)"
                    v-model="login.password"
                    placeholder="Ingresá tu contraseña"
                  />
                </div>

                <transition name="slideAnim" type="animation" appear mode="out-in">
                  <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>
                </transition>

                <div style="text-align:center">
                  <button
                    type="button"
                    class="btn boton-primario"
                    @click="hacerLogin(login)"
                  >Ingresar</button>
                  <router-link
                    to="/Registrate"
                    tag="button"
                    class="btn boton-secundario"
                    v-if="noRegistro"
                  >Registrarme</router-link>

                  <h6 class="olvide-password" @click="olvidePassword()">Olvidé mi contraseña</h6>
                  <h6
                    style="text-align:center; padding:0px "
                    class="olvide-password"
                    @click="ingresaOtraCuenta=false"
                  >Cambiar de usuario</h6>
                </div>
              </div>

              <div
                v-if="loginNuevoUsuario"
                style="padding:20px; border-radius:15px; margin-top:20px"
              >
                <h4 style="text-align:center; padding-bottom:15px">Ingresá a Arkidia</h4>

                <div class="form-group">
                  <label>Usuario</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="login.usuario"
                    aria-describedby="emailHelp"
                    placeholder="Ingresá tu usuario"
                  />
                </div>

                <div class="form-group">
                  <label>Contraseña</label>
                  <input
                    type="password"
                    class="form-control"
                    v-on:keyup.enter="hacerLogin(login)"
                    v-model="login.password"
                    placeholder="Ingresá tu contraseña"
                  />
                </div>

                <transition name="slideAnim" type="animation" appear mode="out-in">
                  <div v-if="errorMessage" class="alert alert-danger" role="alert">{{errorMessage}}</div>
                </transition>

                <div style="text-align:center">
                  <button
                    type="button"
                    class="btn boton-primario"
                    @click="hacerLogin(login)"
                  >Ingresar</button>
                  <router-link
                    to="/Registrate"
                    tag="button"
                    class="btn boton-secundario"
                    v-if="noRegistro"
                  >Registrarme</router-link>

                  <h6 class="olvide-password" @click="olvidePassword()">Olvidé mi contraseña</h6>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <b-modal ref="eliminar-modal" hide-footer title="¿Eliminar Cuenta?">
      <div class="d-block text-center">
        <p>Vas a eliminar a este usuario de tu navegador. Si querés verlo nuevamente, tendrás que ingresar a Arkidia con esta cuenta</p>
      </div>
      <b-button
        class="mt-3"
        variant="danger"
        block
        @click="eliminarUsuario(arkidianSeleccionado, indexArkidianSeleccionado)"
      >Eliminar</b-button>
      <b-button class="mt-2" variant="warning" block @click="cerrarEliminar">Cerrar</b-button>
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Arkidian from "../shared/Arkidian";

export default {
  name: "login",

  data() {
    return {
      loginNuevoUsuario: false,
      eliminaArkidian: false,
      arkidians: [],
      arkidian: {
        nombre: "",
        preferencias: {
          color: "",
          body: "",
          face: "",
          hair: "",
          avatar: "",
          animated: false
        }
      },
      indexArkidianSeleccionado: null,
      arkidianSeleccionado: null,
      ingresaOtraCuenta: false,

      errorMessage: "",
      successMessage: "",
      name: "",
      noRegistro: false,
      firstTime: false,
      login: {
        usuario: "",
        password: ""
      }
    };
  },

  computed: {
    ...mapGetters(["pathAPI", "userLogged"])
  },
  props: ["usuario"],

  methods: {
    cerrarEliminar() {
      this.$refs["eliminar-modal"].hide();
    },
    olvidePassword() {
      this.$router.push({ path: "/Recuperar" });
    },
    hacerLogin(login) {
      var self = this;
      self.errorMessage = "";

      fetch(this.$store.state.pathAPI + "login.php", {
        method: "POST",
        body: "usuario=" + login.usuario + "&password=" + login.password,
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        })
      }).then(function(response) {
        if (response.ok) {
          var loginResponse = response.json();
          loginResponse.then(function(result) {
            if (result.resultado == "ERROR") {
              self.errorMessage = result.mensaje;
              if (result.mensaje == "El usuario no está registrado.") {
                self.noRegistro = true;
              }
            } else {
              if (result.mensaje == "REGISTRO") {
                self.$router.push({
                  path: "/CodigoSecreto/Registro/" + login.usuario
                });
              }
              if (result.mensaje == "OLVIDO") {
                self.$router.push({
                  path: "/CodigoSecreto/Olvido/" + login.usuario
                });
              }
              if (result.mensaje == "") {
                sessionStorage.setItem("t", result.token);
                if (result.page == "HIJO") {
                  self.buscarPerfil(login.usuario);
                  self.cantidadNotificaciones(login.usuario);
                  self.agregarUsuarioCookie(login.usuario);
                } else {
                  self.$store.state.userLogged.profile = result.page;
                  self.$store.state.userLogged.name = result.user;
                  self.$store.state.userLogged.user = login.usuario;
                  self.agregarUsuarioCookie(login.usuario);

                  self.$router.push({ path: "/" });
                }
              }
            }
          });
        } else {
          throw "Error en la llamada Ajax";
        }
      });
    },
    hacerLoginToken(usuario, token) {
      console.log("el usuario es " + usuario);
      console.log("el token es " + token);
      sessionStorage.setItem("t", token);

      this.buscarPerfil(usuario);
      this.cantidadNotificaciones(usuario);
      this.agregarUsuarioCookie(usuario);
    },
    buscarPerfil(usuario) {
      console.log(usuario);
      fetch(this.$store.state.pathAPI + "perfil_usuario.php?usuario=" + usuario)
        .then(response => response.json())
        .then(data => {
          console.log(data);
          console.log(this.$store.state.userLogged);
          if (data.profile == "HIJO" || data.tipo == "HIJO") {
            this.$store.state.userLogged.preferencias.avatar = data.avatar;
            this.$store.state.userLogged.avatar = data.avatar;
            this.$store.state.userLogged.profile = "HIJO";
            this.$store.state.userLogged.name = data.alias;
            this.$store.state.userLogged.user = usuario;
            this.$store.state.userLogged.preferencias.animated = true;
            if (data.arkidian_usuario.length > 0) {
              this.$store.state.userLogged.preferencias.color =
                "fill:#" + data.arkidian_usuario[0].color;
              this.$store.state.userLogged.preferencias.body =
                data.arkidian_usuario[0].cuerpo;
              this.$store.state.userLogged.preferencias.hair =
                data.arkidian_usuario[0].pelo;
              this.$store.state.userLogged.preferencias.face =
                data.arkidian_usuario[0].cara;
            } else {
              this.$store.state.userLogged.preferencias.color = "";
              this.$store.state.userLogged.preferencias.body = "";
              this.$store.state.userLogged.preferencias.hair = "";
              this.$store.state.userLogged.preferencias.face = "";
            }
            console.log("entrando como hijo");
            console.log(this.$store.state.userLogged);
            this.$router.push({ path: "/" });
          } else {
            console.log(usuario);
            this.$store.state.userLogged.user = usuario;
            this.$store.state.userLogged.profile = data.tipo;
            this.$store.state.userLogged.name = data.nombre;

            this.$router.push({ path: "/" });
          }
        });
    },
    agregarUsuarioCookie(usuario) {
      usuario = usuario.toLowerCase();
      var usrSeparados = [];
      if (this.getCookie("arkidians")) {
        usrSeparados = this.getCookie("arkidians").split(",");
      }

      for (var i = 0; i < usrSeparados.length; i++) {
        if (usrSeparados[i] == usuario) {
          return;
        }
      }
      usrSeparados.push(usuario);
      document.cookie = "arkidians=" + usrSeparados.join();
    },
    cantidadNotificaciones(usuario) {
      fetch(this.$store.state.pathAPI + "notificaciones.php?usuario=" + usuario)
        .then(response => response.json())
        .then(data => {
          var cont = 0;
          for (var i = 0; i < data.length; i++) {
            if (data[i].indicador_visto == "N") {
              cont++;
            }
          }
          this.$store.state.counter = cont;
        });
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    separaUsuarios(usuarios) {
      var ca = usuarios.split(",");
    },
    volver() {
      this.$router.push({ path: "/" });
    },
    elegirArkidian(arkidian, index) {
      if (this.eliminaArkidian) {
        this.$refs["eliminar-modal"].show();
        this.arkidianSeleccionado = arkidian;
        this.indexArkidianSeleccionado = index;
      } else {
        this.arkidianSeleccionado = arkidian;
        this.ingresaOtraCuenta = true;
        this.login.usuario = arkidian.usuario;
      }

      //this.$router.push({ path: "/" });
    },
    usarOtraCuenta() {
      this.loginNuevoUsuario = true;
      this.arkidianSeleccionado = null;
    },
    eliminarUsuario(arkidian, index) {
      this.arkidians.splice(index, 1);
      if (this.arkidians.length == 0) {
        this.loginNuevoUsuario = true;
      }
      var userCookies = [];
      for (var i = 0; i < this.arkidians.length; i++) {
        userCookies.push(this.arkidians[i].usuario);
      }
      document.cookie = "arkidians=" + userCookies.join();

      this.$refs["eliminar-modal"].hide();
    }
  },
  computed: {},
  components: { arkidian: Arkidian },

  mounted: function() {
    if (this.usuario == "Registro") {
      this.successMessage = "¡Ya confirmamos tu mail!";
    }
    if (this.usuario == "Olvido") {
      this.successMessage = "Ingresá con tu nueva contraseña";
    }
    if (this.usuario.length > 200) {
      fetch(this.$store.state.pathAPI + "token.php?token=" + this.usuario)
        .then(response => response.json())
        .then(data => {
          if (data.resultado != "ERROR") {
            console.log("login token");
            console.log(data);
            console.log(this.usuario);
            this.hacerLoginToken(data.usuario, this.usuario);
          }
        });
    }
    this.arkidians = [];

    if (this.getCookie("arkidians")) {
      var usrSeparados = this.getCookie("arkidians").split(",");

      for (var i = 0; i < usrSeparados.length; i++) {
        var usr = usrSeparados[i];

        if (usrSeparados[i] > "") {
          this.axios
            .get(
              this.$store.state.pathAPI +
                "perfil_usuario.php?usuario=" +
                usrSeparados[i]
            )
            .then(response => {
              if (response.data.tipo == "HIJO") {
                if (response.data.arkidian_usuario.length > 0) {
                  this.arkidians.push({
                    nombre: response.data.alias,
                    usuario: response.data.usuario,
                    preferencias: {
                      color: "fill:#" + response.data.arkidian_usuario[0].color,
                      body: response.data.arkidian_usuario[0].cuerpo,
                      face: response.data.arkidian_usuario[0].cara,
                      hair: response.data.arkidian_usuario[0].pelo,
                      avatar: response.data.arkidian_usuario[0].avatar,
                      animated: false
                    }
                  });
                } else {
                  this.arkidians.push({
                    nombre: response.data.alias,
                    usuario: response.data.usuario,
                    preferencias: {
                      avatar: response.data.avatar
                    }
                  });
                }
              } else {
                this.arkidians.push({
                  nombre: response.data.nombre,
                  usuario: response.data.usuario,

                  preferencias: {
                    color: null,
                    body: null,
                    face: null,
                    hair: null,
                    avatar: null,
                    animated: null
                  }
                });
              }
            })
            .catch(error => {
              console.log("Error al acceder");
              this.errored = true;
            })
            .finally(() => {
              if (this.arkidians.length == 0) {
                this.loginNuevoUsuario = true;
              }
            });
        }
      }
    } else {
      this.loginNuevoUsuario = true;
    }
  }
};
</script>

<style scoped>
#login {
  background: url("/public/images/site/background-login.svg");
  background-repeat: repeat-x;
  display: table;
  background-size: 1000px;

  width: 100%;
  background-position-y: top;
}

.olvide-password {
  margin: 15px;
  padding: 5px 20px;
  border-radius: 20px !important;
  border: 0px !important;
  align-items: center;
  transition: 0.2s;
  cursor: pointer;
  font-size: 15px;
  font-family: "Patua One", cursive;
  color: rgb(93, 93, 93);
}
.olvide-password:hover {
  transition: 0.2s;
  z-index: 1;
  color: #9546af;
}

.login {
  min-width: 300px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}

.close {
  padding: 0px;
  font-size: 40px;
  font-weight: 300;
}
.label {
  margin-bottom: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/Login.vue